import React from 'react';
import styled from 'styled-components';
import { Button } from '@bijie/react-bnb';
import { connect } from 'react-redux';
import withi18n from '../../utils/withI18n';
import { getLabel } from '../../utils/i18n';

const StyledHeader = styled.header`
  /* position: fixed;
  top: 0;
  left: 0; */
  display: flex;
  align-items: center;
  height: 64px;
  padding: 0px 16px;
  width: 100%;
  background-color: #0b0e11;
  box-sizing: border-box;
  justify-content: space-between;
  img {
    width: 138px;
  }
`;
const Right = styled.div`
  .login{
    color:#fff;
    margin-right:12px;
  }
`;
const Login = styled.span`
    display: inline-block;
    height: 38px;
    width: 38px;
    text-align: center;
    line-height: 33px;
    font-size: 20px;
    font-weight: 600;
    box-sizing: border-box;
    border-radius: 50%;
    border-width: 1px;
    border-style: solid;
    color: #fff;
    border-color: rgb(255, 255, 255);
`;

type Props = {
  isLoggedIn: Boolean,
  locale: string,
  i18n: Object,
  userInfo: Object,
}

const mapStateToProps = ({
  isLoggedIn, userInfo,
}) => ({
  isLoggedIn, userInfo,
});


export default
@withi18n
@connect(
  mapStateToProps,
  null
)
class MobileHeader extends React.Component<Props> {
  static defaultProps = {
    isLoggedIn: false,
    i18n: {},
    locale: 'en',
    userInfo: {},
  };


  render() {
    const {
      locale, isLoggedIn, userInfo, i18n,
    } = this.props;
    const logoSrc = locale === 'cn' ? require('../Logo/logo-cn.svg') : require('../Logo/logo-en.svg');
    return (
      <StyledHeader>
        <a href={`/${locale}`}>
          <img
            /* eslint-disable-next-line */
            src={logoSrc}
            alt=""
            draggable={false}
          />
        </a>
        {
          isLoggedIn === true ?
            <Right>
              <a href={`/${locale}/usercenter/dashboard/overview`}><Login>{(userInfo.email || '').substr(0, 2)}</Login></a>
            </Right> : null
          }
        {
          isLoggedIn === false ?
            <Right>
              <a href={`/${locale}/login`}><span className="login">{getLabel('exchange-login-signIn', i18n)}</span></a>
              <a href={`/${locale}/register`}><Button outline={true} type="primary">{getLabel('exchange-header-register', i18n)}</Button></a>
            </Right> : null
          }
      </StyledHeader>
    );
  }
}
